export default __webpack_public_path__ + "static/media/trash-icon.8b9ea16a.svg";